export const CURRENT_ENV = import.meta.env.VITE_CURRENT_ENV;
export const CURRENT_ENVIRONMENT_SUFFIX = CURRENT_ENV === "production" ? "" : ` - ${CURRENT_ENV}`;
export const APP_NAME = "parking-drawer-" + CURRENT_ENV;
export const VITE_API_SITES_BASE_URL = import.meta.env.VITE_API_SITES_BASE_URL;
